// extracted by mini-css-extract-plugin
export default {"container":"CompanyDataExport_container__bibO3","header":"CompanyDataExport_header__HWETe","alert":"CompanyDataExport_alert__n70q8"};